import React from 'react';
import * as Scroll from 'react-scroll'; 
import Presenter from '../../../presenter.js';

import FilterComponent from '../../../../asset/simple_asset/helper/component/FilterComponent.js';

// Component
import MaintenanceRow from './MaintenanceRow.js';
import ModalMaintenanceAdd from '../Modal/ModalMaintenanceAdd.js';
import ModalMaintenanceEdit from '../Modal/ModalMaintenanceEdit.js';
import ModalReminderEdit from '../../../../remainder/helper/component/Modal/ModalRemainderEdit.js';
import ModalReminderAdd from '../../../../remainder/helper/component/Modal/ModalRemainderAdd.js';
import ModalStartWork from '../Modal/ModalStartWork.js';
import ModalFinishWork from '../Modal/ModalFinishWork.js'; 
import RequestProperties from 'maintenance/helper/request.props.js'; /*before use this but, make an error (not a Function)*/
//Icon
import iconMaping from '../../../../utils/IconMaping.js';

//Utils
import {HandlingSometingWentWrong} from '../../../../utils/HandlingMessage.js'
/*import TimerConfig from '../../../../utils/TimerConfig.js';*/
import { toast } from 'react-toastify';
import Pagination from '../../../../component/Pagination.js'
import classnames from 'classnames'
import windowStop from '../../../../utils/windowStop.js';

// import Drawer from 'component/Drawer.js'

// // let scroll     = Scroll.animateScroll;
var Events     = Scroll.Events;
var scroll     = Scroll.animateScroll;
var scrollSpy  = Scroll.scrollSpy;


export default class MaintenanceList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading         : true,
      isLoadingLoadmore : true,
      modalAdd          : false,
      modalEdit         : false,
      modalEditReminder : false,
      modalAddReminder  : false,
      modalStartWork    : false,
      modalFinishWork   : false,
      tmpRemainder      : false,
      total             : 0,
      rawData           : [],
      activeToggle: {
        activeIcon: null,
        activeField: 'Name',
      },

      // Modal update reminder
      update: false,
      updateData: [],

      // Modal add reminder
      work: {
        alias: '',
      },
      // ***Pagination
      table_loading : false,
      current       : 0,
      limit         : 0,

      // Drawer
      // visible : false
    }

    // Drawer data source
    // this.dataSource = []

    // Component Filter
    this.tab1 = ['maintenance', 'asset']

    //* Default Param Filter & Order */
    this.ParamsFilter = 'field=&search=';
    this.ParamsOrder  = 'ordering=-SortDate,-CreatedTime';
    this.ParamsPage   = 1;

    // Read
    this.onRead        = this.onRead.bind(this)
    this.onReadSuccess = this.onReadSuccess.bind(this)
    this.onReadFailed  = this.onReadFailed.bind(this)

    // toggle 
    this.toggleModalAdd = this.toggleModalAdd.bind(this) 
    
    // modal
    this.openModalEdit          = this.openModalEdit.bind(this)
    this.closeModalEdit         = this.closeModalEdit.bind(this)
    
    this.openModalReminderEdit  = this.openModalReminderEdit.bind(this)
    this.closeModalReminderEdit = this.closeModalReminderEdit.bind(this)

    this.openModalReminderAdd   = this.openModalReminderAdd.bind(this)
    this.closeModalReminderAdd  = this.closeModalReminderAdd.bind(this)

    this.openModalStartWork     = this.openModalStartWork.bind(this)
    this.closeModalStartWork    = this.closeModalStartWork.bind(this)

    this.openModalFinishWork    = this.openModalFinishWork.bind(this)
    this.closeModalFinishWork   = this.closeModalFinishWork.bind(this)
    
    this.onStartWork            = this.onStartWork.bind(this)
    this.onStartWorkSuccess     = this.onStartWorkSuccess.bind(this)
    this.onStartWorkFailed      = this.onStartWorkFailed.bind(this)

    this.onQuickTest            = this.onQuickTest.bind(this)
    this.onQuickTestSuccess     = this.onQuickTestSuccess.bind(this)
    this.onQuickTestFailed      = this.onQuickTestFailed.bind(this)
    
    // this.onFinishWork           = this.onFinishWork.bind(this)
    this.onFinishWorkSuccess    = this.onFinishWorkSuccess.bind(this)
    this.onFinishWorkFailed     = this.onFinishWorkFailed.bind(this)
    
    this.updateRow              = this.updateRow.bind(this);
    this.offTmpRemainder        = this.offTmpRemainder.bind(this);
    this._mounted               = false;
  }

  updateRow(update) {
    this.setState({update: update})
  }

  // Finish
  onStartWork(data) {
    Presenter.StartWork(
      RequestProperties.StartWork(data, this, this.onStartWorkSuccess, this.onStartWorkFailed)
    )
  }

  onStartWorkSuccess(params, response) {
    toast.success("Execute Success")
    this.onRead();
    this.closeModalStartWork();
  }

  onStartWorkFailed(response) {
    toast.error(response.data.detail);
  }

  onQuickTest(alias) {
    Presenter.QuickTest(
      RequestProperties.QuickTest(alias, this, this.onQuickTestSuccess, this.onQuickTestFailed)
    )
  }
  onQuickTestSuccess(params, response) {
    toast.success("Quick Test Success")
    this.onRead();
  }
  onQuickTestFailed(response) {
    try {
      toast.error(response.data.detail); 
    } catch (error) {
      console.log(error)
    }
  }

  onFinishWorkSuccess(params, response) {
    this.onRead();
    this.closeModalFinishWork();
  }

  onFinishWorkFailed(response) {
    console.log('Failed');
  }

  openModalStartWork(alias){
    this.setState({
      work : {
        alias : alias,
      },
      modalStartWork : true
    })
  }

  closeModalStartWork(){
    this.setState({ modalStartWork : false })
  }

  openModalFinishWork(alias){
    this.setState({
      work : {
        alias : alias,
      },
      modalFinishWork : true
    })
  }

  closeModalFinishWork(){
    this.setState({ modalFinishWork : false })
  }

  toggleModalAdd() {
    this.setState({modalAdd: !this.state.modalAdd})
  }

  openModalEdit(data){
    this.setState({
      RowData: data,
      modalEdit: true
    })
  }

  closeModalEdit(){
    this.setState({
      modalEdit: false
    })
  }


  // Open modal reminder edit
  openModalReminderEdit(data) {this.setState({updateData: data,modalEditReminder: true})}
  closeModalReminderEdit() {this.setState({modalEditReminder: false})}  


  // Open modal reminder add
  openModalReminderAdd(alias) {
    this.setState({
      work: {
        alias: alias
      },
      modalAddReminder: true,
      tmpRemainder: true
    })
  }
  
  closeModalReminderAdd() {this.setState({modalAddReminder: false})}

  offTmpRemainder() {
    this.setState({tmpRemainder: false})
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (
        <MaintenanceRow 
          self={this} 
          RowData={val} 
          key={index}
          Cluster={this.props.Cluster}
          onStartWork={this.openModalStartWork}
          onStartQuickTest={this.onQuickTest}
          onFinishWork={this.openModalFinishWork}
          history = {this.props.history}
        />
      )
    })
    return element;
  }

  /* On Filter */
  dataWillFilter(filter){
    this.ParamsFilter = filter;
    this.ParamsPage   = 1;
    this.onRead();
  }

  /* On Order */
  dataWillOrder(order){
      let parameterOder = 'ordering=' + order;
      this.setState({activeToggle: {
          activeField : order,
          activeIcon  : iconMaping.AVICON_ASC    
      } })

      if (this.ParamsOrder === parameterOder) {
          this.ParamsOrder = 'ordering=-' + order;
          this.setState({activeToggle: {
              activeField : order,
              activeIcon  : iconMaping.AVICON_DESC
          } })
      } else {
          this.ParamsOrder = parameterOder;
          this.setState({activeToggle: {
              activeField : order,
              activeIcon  : iconMaping.AVICON_ASC    
          } })
      }

      this.onRead();
  }

  /* On Read All Data */
  onRead() {
    if (this._mounted){
      Presenter.Read(
        RequestProperties.Read(
          'Read', this, 
          this.onReadSuccess, 
          this.onReadFailed, 
          this.ParamsFilter, 
          this.ParamsOrder,
          this.ParamsPage
        )
      )
    }
  }

  onReadSuccess(params, response) {
    if (this._mounted){
      if(params.action === 'Read') {
        this.setState({
          isLoading         : false,
          isLoadingLoadmore : false,
          // isSometingWrong   : false,
          table_loading     : false,
          total             : response.data.count,
          nextPage          : response.data.next,
          rawData           : response.data.results,
          //Pagination
          current           : response.data.current,
          limit             : response.data.limit,
        })

      }
    }
  }

  onReadFailed(response) {
    if (this._mounted){
      console.log("Read Failed");
      this.setState({
        table_loading: false
      })
    }
  } 

  handlePageClick = (data) => {
    windowStop()
    let selected = data.selected + 1;
    this.ParamsPage = selected
    this.setState({ table_loading: true})
    this.onRead();
  };

  /* Readmore */
  LoadMore() {        
    this.setState({isLoadingLoadmore: true})
    Presenter.Read( 
      RequestProperties.Read("Next", this, this.onReadSuccess, this.onReadFailed) 
    )
  }

  renderLoadMoreButton() {
    if(this.state.isLoadingLoadmore) {
      return(<div><button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button></div>)
    } else {
      if(this.state.nextPage != null) {
        return (<div><button className="btn btn-primary" onClick={()=> {this.LoadMore()}}>Load More</button></div>)
      }
    }
  }

  scrollToTop() {
    scroll.scrollToTop();
  }

  componentDidMount() {
    this._mounted = true;
    this.onRead();

    Events.scrollEvent.register('begin', function(to, element) {});
    Events.scrollEvent.register('end', function(to, element) {})
    scrollSpy.update();
  }

  componentWillUnmount() {
    this._mounted = false;
    windowStop()
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
  } 

  renderTitle(cluster) {
    if(cluster === 'all') {
      return(
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span><span className={iconMaping.AVICON_MAINTENANCE}></span>&nbsp;All Maintenance</span>
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                <span>Total:&nbsp;{this.state.total}</span>&nbsp;Maintenance
                <button className="ml-2 btn btn-outline-primary btn-sm" onClick={this.onRead}>
                  <i className="fa fa-refresh fa-lg"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent onSearch={(e) => {this.dataWillFilter(e)}} self={this} target={'all'} FBColumn={this.tab1}></FilterComponent>
          </div>
        </div>
      )
    } else if(cluster === 'upcoming') {
      return (
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span><span className={iconMaping.AVICON_MAINTENANCE}></span>&nbsp;Incomplete Maintenance</span>
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                <span>Total:&nbsp;{this.state.total}</span>&nbsp;Maintenance
                <button className="ml-2 btn btn-outline-primary btn-sm" onClick={this.onRead}>
                  <i className="fa fa-refresh fa-lg"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent onSearch={(e) => {this.dataWillFilter(e)}} self={this} target={'upcoming'} FBColumn={this.tab1}></FilterComponent>
          </div>
        </div>
      )
    } else if(cluster === 'ongoing'){
      return (
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span><span className={iconMaping.AVICON_MAINTENANCE}></span>&nbsp;Ongoing Maintenance</span>
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                <span>Total:&nbsp;{this.state.total}</span>&nbsp;Maintenance
                <button className="ml-2 btn btn-outline-primary btn-sm" onClick={this.onRead}>
                  <i className="fa fa-refresh fa-lg"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent onSearch={(e) => {this.dataWillFilter(e)}} self={this} target={'ongoing'} FBColumn={this.tab1}></FilterComponent>
          </div>
        </div>
      )
    } else {
      return (
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span><span className={iconMaping.AVICON_MAINTENANCE}></span>&nbsp;Completed Maintenance</span>
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                <span>Total:&nbsp;{this.state.total}</span>&nbsp;Maintenance
                <button className="ml-2 btn btn-outline-primary btn-sm" onClick={this.onRead}>
                  <i className="fa fa-refresh fa-lg"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent onSearch={(e) => {this.dataWillFilter(e)}} self={this} target={'past'} FBColumn={this.tab1}></FilterComponent>
          </div>
        </div>
      )
    }
  }

  renderRowElement() {
    if ( this.state.isLoading ) {
      return (<tr><td className="table-loading-inside" colSpan="100%">Loading data . . .</td></tr>)
    } 
    else if (this.state.rawData.length === 0) {
      return (<tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>)
    } 
    else if (this.state.rawData.length > 0) {
      return (this.generateRow(this.state.rawData))
    } 
    else {
      return(HandlingSometingWentWrong('table'))
    }
  }

  // getDetail = (data) => {
  //   console.log(data)

  //   this.dataSource = [{
  //     field: 'Asset Name',
  //     value: data.Asset.Name
  //   }, {
  //     field: 'Asset Alias',
  //     value: data.Asset.Alias
  //   }]

  //   this.showDrawer()
  // }

  // showDrawer = () => {
  //   this.setState({
  //     visible: true
  //   })
  // }

  // closeDrawer = () => {
  //   this.setState({
  //     visible: false
  //   })
  // }

  render() {

    return (
      <div>
        {/* <Drawer 
          visible = {this.state.visible}
          onClose = {this.closeDrawer}
          dataSource = {this.dataSource}
        /> */}
        {this.renderTitle(this.props.Cluster)}
        <div className="row">
          <div className="col-md-12 mt-4">
            <button onClick={()=>this.toggleModalAdd()} className="btn btn-sm btn-primary">Add New</button>
          </div>
        </div>
        <table className={classnames("table table-responsive table-hover table-outline mb-0 m-top-15 over-x", {"loading" : this.state.table_loading})}>
          <thead className="thead-default">
            <tr>
                <th onClick={()=>this.dataWillOrder('Asset__Name')} className="pointer">
                  Asset/Tool{this.state.activeToggle.activeField === 'Asset__Name' ? <i className={this.state.activeToggle.activeIcon}></i> : ''}
                </th>
                <th onClick={()=>this.dataWillOrder('Service__Name')} className="text-center pointer">
                  Maintenance{this.state.activeToggle.activeField === 'Service__Name' ? <i className={this.state.activeToggle.activeIcon}></i> : ' '}
                </th>
                <th onClick={()=>this.dataWillOrder('ScheduledStart')} className="text-center pointer">
                  Scheduled Start{this.state.activeToggle.activeField === 'ScheduledStart' ? <i className={this.state.activeToggle.activeIcon}></i> : ' '}
                </th>
                <th onClick={()=>this.dataWillOrder('ScheduledEnd')} className="text-center pointer">
                  Scheduled End{this.state.activeToggle.activeField === 'ScheduledEnd' ? <i className={this.state.activeToggle.activeIcon}></i> : ' '}
                </th>
                <th className="text-center">
                  Reminder
                </th>
                <th className="text-center">
                  Edit
                </th>
                <th className="text-center">
                  Action
                </th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowElement()}
          </tbody>
        </table>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            <Pagination
              current  = {this.state.current}
              count    = {this.state.total}
              limit    = {this.state.limit}
              handle   = {this.handlePageClick}
              isLoading= {this.state.table_loading}
            />
            <button className="back-to-top" onClick={()=>this.scrollToTop()}><i className="icon-arrow-up"></i></button>
          </div>
        </div>
        
        <ModalMaintenanceAdd 
          toggleModalAdd = {this.toggleModalAdd}
          modalAdd       = {this.state.modalAdd}
          UserReducer    = {this.props.UserReducer}
          loadData       = {this.onRead} 
        />
        
        <ModalMaintenanceEdit 
          modalEdit             = {this.state.modalEdit}
          closeModalEdit        = {this.closeModalEdit}
          RowData               = {this.state.RowData}
          UserReducer           = {this.props.UserReducer}
          loadData              = {this.onRead}

          openModalReminderEdit = {this.openModalReminderEdit}
          openModalReminderAdd  = {this.openModalReminderAdd}
          tmpRemainder          = {this.state.tmpRemainder}
          offTmpRemainder       = {this.offTmpRemainder} 
        />

        <ModalReminderEdit 
          modalEdit   = {this.state.modalEditReminder}
          updateData  = {this.state.updateData}
          UserReducer = {this.props.UserReducer}
          updateRow   = {this.updateRow}
          closeModal  = {this.closeModalReminderEdit}
        />

        <ModalReminderAdd 
          modalRegister = {this.state.modalAddReminder}
          closeModal    = {this.closeModalReminderAdd}
          UserReducer   = {this.props.UserReducer}
          updateRow     = {this.updateRow}
          newRow        = {this.updateRow}
          work          = {this.state.work}
        />

        <ModalStartWork
          modalStartWork  = {this.state.modalStartWork}
          work            = {this.state.work}
          closeModal      = {this.closeModalStartWork}
          onStartWork     = {this.onStartWork}
          UserReducer     = {this.props.UserReducer}
        />
        
        <ModalFinishWork
          modalFinishWork     = {this.state.modalFinishWork}
          work                = {this.state.work}
          closeModal          = {this.closeModalFinishWork}
          onFinishWorkSuccess = {this.onFinishWorkSuccess}
          onFinishWorkFailed  = {this.onFinishWorkFailed}
          UserReducer         = {this.props.UserReducer}
        />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/MaintenanceList/MaintenanceList.js